var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.858,
    height: 14.913,
    viewBox: "0 0 21.858 14.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.953,2.441a11.3,11.3,0,0,1,6.642,2.074A11.677,11.677,0,0,1,21.858,9.9a11.686,11.686,0,0,1-4.265,5.383,11.3,11.3,0,0,1-6.641,2.074,11.408,11.408,0,0,1-6.665-2.074A11.631,11.631,0,0,1,0,9.9,11.637,11.637,0,0,1,4.288,4.515,11.406,11.406,0,0,1,10.953,2.441Zm0,12.444a4.722,4.722,0,0,0,3.5-1.468A4.84,4.84,0,0,0,15.892,9.9a4.84,4.84,0,0,0-1.445-3.518,4.722,4.722,0,0,0-3.5-1.468A4.8,4.8,0,0,0,7.434,6.379,4.8,4.8,0,0,0,5.966,9.9a4.8,4.8,0,0,0,1.468,3.518A4.8,4.8,0,0,0,10.953,14.885Zm-.023-7.969a2.932,2.932,0,0,1,2.12.862,2.844,2.844,0,0,1,.885,2.12,2.844,2.844,0,0,1-.885,2.12,2.932,2.932,0,0,1-2.12.862,2.855,2.855,0,0,1-2.1-.862A2.884,2.884,0,0,1,7.969,9.9a2.944,2.944,0,0,1,2.959-2.983Z",
    transform: "translate(0 -2.441)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.74dcf2acbca7a27d79f738fe6599d4f4.svg";
export { ForwardRef as ReactComponent };